import { render, staticRenderFns } from "./faq_detail.vue?vue&type=template&id=2e6599cb&scoped=true&"
import script from "./faq_detail.vue?vue&type=script&lang=js&"
export * from "./faq_detail.vue?vue&type=script&lang=js&"
import style0 from "./faq.css?vue&type=style&index=0&id=2e6599cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6599cb",
  null
  
)

export default component.exports